import React from 'react';

const BoltOffSvg = (props) => (
    <svg
        className="bolt-off_svg__eds-icon--bolt-off_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="bolt-off_svg__eds-icon--bolt-off_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7 15L19 9h-7V2L8.7 8l-6-6-.7.7L21.3 22l.7-.7-6.3-6.3zM9.5 8.8L11 6v4h6.3L15 14.3 9.5 8.8z"
        />
        <path
            className="bolt-off_svg__eds-icon--bolt-off_bottom"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.6 17.1l-.7-.7L13 18v-2.5L11.5 14H6.7l1.7-3.2-.8-.7L5 15h7v7z"
        />
    </svg>
);

BoltOffSvg.displayName = 'BoltOffSvg';
export default BoltOffSvg;
